import { MOKA_SERVICE_HOST } from 'api/constants';

export const PIN_URL = `${MOKA_SERVICE_HOST}/account/v1/permissions/settings/pin`;
